import React from 'react';
import WebMarketTickerComponent from '@keytrade/web-market-ticker';

import RenderOnClientHOC from '../shared/RenderOnClientHOC';

const WebMarketTicker: React.FC = () => <WebMarketTickerComponent />;

export default RenderOnClientHOC(WebMarketTicker);
